/* Coty Optique — theme.js (vanilla, sans dépendance) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* Hauteur du header (toolbar et fiche produit collantes) */
  const header = $('.section-header') || $('[data-header]');
  const setH = () => header && document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  setH(); addEventListener('resize', setH);

  /* Recherche */
  const searchForm = $('[data-search]');
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    searchForm.hidden = !searchForm.hidden;
    if (!searchForm.hidden) $('input[type=search]', searchForm).focus();
    setH();
  }));

  /* Menu mobile */
  const drawer = $('[data-drawer]');
  const toggleDrawer = open => { if (!drawer) return; drawer.hidden = !open; document.body.style.overflow = open ? 'hidden' : ''; };
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => toggleDrawer(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => toggleDrawer(false)));
  addEventListener('keydown', e => e.key === 'Escape' && toggleDrawer(false));

  /* Carrousels */
  const initCarousels = (root = document) => $$('[data-carousel]', root).forEach(c => {
    const track = $('[data-carousel-track]', c), bar = $('[data-carousel-bar]', c);
    const prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      if (bar) { bar.style.width = Math.max(ratio * 100, 8) + '%'; bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0}%)`; }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      const ctrls = $('.carousel__controls', c); if (ctrls) ctrls.style.display = max <= 2 ? 'none' : '';
    };
    const step = () => (track.querySelector('.carousel__slide')?.offsetWidth || 300) + 24;
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update); update();
  });
  initCarousels();

  /* Cartes produit : pastilles couleurs -> change l'image et le lien (façon Cutler and Gross) */
  const bindCards = (root = document) => $$('[data-card]', root).forEach(card => {
    const img = $('[data-card-img]', card);
    const links = $$('[data-card-link]', card);
    const swatches = $$('[data-swatch]', card);
    const apply = sw => {
      swatches.forEach(s => s.classList.toggle('is-active', s === sw));
      links.forEach(l => (l.href = sw.dataset.href));
      if (img && sw.dataset.src && img.getAttribute('src') !== sw.dataset.src) {
        img.classList.add('is-swapping');
        const pre = new Image();
        pre.onload = () => { img.srcset = sw.dataset.srcset || ''; img.src = sw.dataset.src; img.classList.remove('is-swapping'); };
        pre.src = sw.dataset.src;
      }
    };
    swatches.forEach(sw => {
      sw.addEventListener('mouseenter', () => apply(sw));
      sw.addEventListener('focus', () => apply(sw));
      sw.addEventListener('click', () => apply(sw));
    });
  });
  bindCards();

  /* Fiche produit */
  const product = $('[data-product]');
  if (product) {
    const data = JSON.parse($('[data-product-json]', product).textContent);
    const mainImg = $('[data-gallery-main]', product);
    const thumbs = $$('[data-thumb]', product);
    const priceEl = $('[data-price]', product), skuEl = $('[data-sku]', product);
    const tryLink = $('[data-try-link]', product);
    const fieldsets = $$('[data-option-index]', product);
    const selected = fieldsets.map(f => $('.is-active', f)?.dataset.value);

    const swapMain = (src, srcset) => {
      if (!mainImg || !src || mainImg.getAttribute('src') === src) return;
      mainImg.classList.add('is-swapping');
      const pre = new Image();
      pre.onload = () => { mainImg.srcset = srcset || ''; mainImg.src = src; mainImg.classList.remove('is-swapping'); };
      pre.src = src;
    };
    thumbs.forEach(t => t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      swapMain(t.dataset.src, t.dataset.srcset);
    }));

    /* Si les textes alternatifs des images portent le nom des couleurs, on filtre la galerie par couleur */
    const handle = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const filterGallery = color => {
      if (data.colorIndex < 0 || !thumbs.length) return;
      const items = $$('[data-media-alt]', product);
      const matches = items.filter(li => li.dataset.mediaAlt === handle(color));
      if (!matches.length) { items.forEach(li => (li.hidden = false)); return; }
      items.forEach(li => (li.hidden = !matches.includes(li)));
    };

    const update = () => {
      const v = data.variants.find(v => v.options.every((o, i) => o === selected[i])) ||
                data.variants.find(v => data.colorIndex >= 0 && v.options[data.colorIndex] === selected[data.colorIndex]);
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (skuEl) skuEl.textContent = v.sku ? (skuEl.dataset.refLabel || 'Réf.') + ' ' + v.sku : '';
      if (v.src) {
        swapMain(v.src, v.srcset);
        thumbs.forEach(t => t.classList.toggle('is-active', +t.dataset.mediaId === v.mediaId));
      }
      if (data.colorIndex >= 0) filterGallery(v.options[data.colorIndex]);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (tryLink) {
        const u = new URL(tryLink.href, location.origin);
        u.searchParams.set('produit', `${data.title} (${v.title})`); tryLink.href = u.pathname + u.search;
      }
    };

    fieldsets.forEach((f, i) => $$('[data-option-btn]', f).forEach(btn => btn.addEventListener('click', () => {
      $$('[data-option-btn]', f).forEach(b => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn); });
      selected[i] = btn.dataset.value;
      const label = $('[data-option-value]', f); if (label) label.textContent = btn.dataset.value;
      update();
    })));
    if (data.colorIndex >= 0) filterGallery(selected[data.colorIndex]);
  }

  /* Produits recommandés */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCarousels(el); bindCards(el); } else el.remove();
    } catch (e) { el.remove(); }
  });

  /* Filtres & tri de collection */
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    const submit = () => {
      const params = new URLSearchParams(new FormData(filterForm));
      location.search = params.toString();
    };
    $$('input[type=checkbox]', filterForm).forEach(i => i.addEventListener('change', submit));
    $('[data-sort]', filterForm)?.addEventListener('change', submit);
    document.addEventListener('click', e => $$('[data-filter][open]').forEach(d => !d.contains(e.target) && d.removeAttribute('open')));
  }

  /* Formulaire RDV : pré-remplissage depuis la fiche produit */
  const params = new URLSearchParams(location.search);
  const productField = $('[data-product-field]');
  if (productField && params.get('produit')) productField.value = params.get('produit');
  const motif = $('[data-motif]');
  if (motif && params.get('motif') === 'essayage') motif.value = 'Essayage de montures';

  /* Apparition douce au scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.section-head, .iwt__content, .iwt__media, .service, .brand, .faq__inner, .banner__content, .trust__item').forEach(el => { el.classList.add('reveal'); io.observe(el); });
  }
})();

/* Coty Optique — tous les boutons « Prendre rendez-vous » ouvrent l'agenda Calendly */
(() => {
  const CAL = 'https://calendly.com/coty-optique76/30min';
  const fix = () => document.querySelectorAll('a').forEach(a => {
    const t = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (/^prendre\s+(un\s+)?(rdv|rendez-vous)/i.test(t) || /calendly\.com/.test(a.getAttribute('href') || '')) { a.href = CAL; a.target = '_blank'; a.rel = 'noopener'; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();

/* Coty Optique — signale une interaction en cours : les effets décoratifs se mettent en pause un instant (INP) */
(() => {
  const mark = () => { window.__cotyBusy = performance.now(); };
  ['pointerdown', 'keydown', 'touchstart'].forEach(t => addEventListener(t, mark, { passive: true, capture: true }));
})();
